var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#ff8a65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29,32c-1.104,0-2-0.896-2-2V17c0-1.104,0.896-2,2-2s2,0.896,2,2v13C31,31.104,30.104,32,29,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23,32c-1.104,0-2-0.896-2-2v-6c0-1.104,0.896-2,2-2s2,0.896,2,2v6C25,31.104,24.104,32,23,32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17,32c-1.104,0-2-0.896-2-2v-1c0-1.104,0.896-2,2-2s2,0.896,2,2v1C19,31.104,18.104,32,17,32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/google-analytics.5b98d3f44f19c2a3d9c98c765bdfd75b.svg";
export { ForwardRef as ReactComponent };